import React from "react";
import ContentEditable from "react-contenteditable";

class InlineEdit extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      refresh: false,
    };

    this.onKeyDown = this.onKeyDown.bind(this);
    this.handleText = this.handleText.bind(this);

    this.editable = React.createRef();
  }

  componentDidMount() {
    this.addEventListeners();
  }

  componentWillUnmount() {
    this.removeEventListeners();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.refresh === true && this.state.refresh === false) {
      this.addEventListeners();
    }
  }

  addEventListeners() {
    this.editable.current.addEventListener("keydown", this.onKeyDown);
  }

  removeEventListeners() {
    this.editable.current.removeEventListener("keydown", this.onKeyDown);
  }

  handleText() {
    this.removeEventListeners();
    this.props.onChange(
      this.props.formattingMethod
        ? this.props.formattingMethod(this.editable.current.innerText)
        : this.editable.current.innerText,
    );
    this.setState({ refresh: true });
    setTimeout(() => this.setState({ refresh: false }));
  }

  onKeyDown(event) {
    if (event.keyCode === 13) {
      event.preventDefault();
      this.handleText();
    }
  }

  render() {
    if (this.state.refresh) {
      return null;
    }

    const { tagName, value, onChange } = this.props;

    return (
      <ContentEditable
        {...this.props}
        innerRef={this.editable}
        tagName={tagName}
        html={value}
        onChange={event => onChange(event.target.value)}
        onBlur={() => this.handleText()}
      />
    );
  }
}

export default InlineEdit;
